/** Takes an Array of Rules and and extracts all the rules
 * recurssively, so that nested RuleSets are all flattened into a
 * single list of rules.
 *
 * Useful for certain scenarios like checking if there are any rules
 * (aside from nested conditionals) in a RuleSet.
 */
export function flattenRules(rules: any[], val = []) {
  rules.forEach(r => {
    if (r.rules) {
      val = flattenRules(r.rules, val);
    } else {
      val = [...val, r];
    }
  });

  return val;
}

